import { backendFetch } from '../../backend/backend';
import React, {useState, useEffect, Fragment } from 'react';
import FixturesTable from '../tables/FixturesTable';
import { Stack, Container } from '@mui/material';
import BaseLeagueTable from '../tables/BaseLeagueTable';
import ResultsByPositionTable from '../tables/ResultsByPositionTable';

const HomePage=()=>{
	const fixturesToShow=3;
	const resultsDaysToShow=2;
	const [nextFixtures,setNextFixtures]=useState([]);
	const [toSeasonEnd,setToSeasonEnd]=useState(false);
	const [league,setLeague]=useState();
	const [resultsTable,setResultsTable]=useState([]);
	const [fetched,setFetched]=useState(false);

	useEffect(()=>{
		const fetchData=async () => {
			const fixtures=await backendFetch('fixtures?season=active&played=false');
			if (fixtures.length>fixturesToShow)
				setNextFixtures(fixtures.slice(0,fixturesToShow));
			else
			{
				setNextFixtures(fixtures);
				setToSeasonEnd(true);
			}
			setLeague(await backendFetch('league?season=active'));
			setResultsTable(await backendFetch('results?season=active'));
			setFetched(true);
		}
		fetchData();
	},[])
	return(
		<Stack>
			{fetched &&
			<Fragment>
				<Stack direction={{xs:"column",md:"row"}}>
					{nextFixtures && <FixturesTable title={toSeasonEnd?"Remaining Fixtures":`Next ${fixturesToShow} fixtures`} fixtures={nextFixtures}/>}
					<Container sx={{minWidth:{xs:0,md:600,lg:800}}} disableGutters>
					{league && <BaseLeagueTable title="Current Standings" variant="minimal" leagueTable={league}/>}
					</Container>
				</Stack>
				{resultsTable && <ResultsByPositionTable title="Recent Results" variant="minimal" resultsTable={resultsTable} numDays={resultsDaysToShow}/>}
				</Fragment>
			}
		</Stack>
	)
}

export default HomePage;
